import { render, staticRenderFns, recyclableRender, components } from "./uni-data-select.vue?vue&type=template&id=6b64008e&"
var renderjs
import script from "./uni-data-select.vue?vue&type=script&lang=js&"
export * from "./uni-data-select.vue?vue&type=script&lang=js&"
import style0 from "./uni-data-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-data-select/components/uni-data-select/uni-data-select.vue"
export default component.exports